import { render } from "./ClientControlAccesoUsuarios.vue?vue&type=template&id=b8f4fea2&scoped=true"
import script from "./ClientControlAccesoUsuarios.vue?vue&type=script&lang=js"
export * from "./ClientControlAccesoUsuarios.vue?vue&type=script&lang=js"

import "./ClientControlAccesoUsuarios.vue?vue&type=style&index=0&id=b8f4fea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f4fea2"]])

export default __exports__